<div (click)="onClick()" [class]="'groups-list-area ' + (params.readOnly ? 'visu-check-groups' : 'edit-check-groups')">
	<ion-item [disabled]="hasPermission === false" lines="none">
		<calao-groups-checklist [data]="params.data" [groupIds]="params.groupIds" [model]="params.model"
			[createButtonText]="params.createButtonText" [readOnly]="params.readOnly" [title]="params.title"
			[roles]="params.roles" [multiple]="params.multiple" [emptyText]="params.emptyText" [hideTitle]="params.hideTitle"
			[sortGroupsByType]="params.sortGroupsByType" (onSelectionChanged)="onSelectionChanged($event)" [min]="params.min">
		</calao-groups-checklist>
	</ion-item>
</div>